export const kMatterArtifactVersionsBasePath = '/api/v2/matter-artifact/versions'
export const kMatterArtifactNameFallback = 'Untitled'

// Shown when a draft's unsaved edits cannot be flushed before an export; exporting anyway would
// silently deliver stale content. Shared by every export path so all of them report it alike.
export const kFlushFailedMessage = "Your latest changes couldn't be saved. Check the save status in the editor toolbar, then try again."
